module.exports = __webpack_public_path__ + "static/media/download.23da7388.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/download.svg
// module id = 69
// module chunks = 0